import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';
import Svg from '@bibliocommons/svg';

import './TableStencil.scss';

export default function TableStencil({ className }) {
  const classNames = cn('cp-table-stencil', className);

  return (
    <div className={classNames}>
      <Svg
        className="table-stencil__desktop"
        width="1247"
        height="169"
        viewBox="0 0 1247 169"
        preserveAspectRatio="none"
      >
        <path
          fillRule="evenodd"
          d="M1247,168 L1247,169 L0,169 L0,168 L1247,168 Z M115,135 L115,149 L24,149 L24,135 L115,135 Z M559,135 L559,149 L306,149 L306,135 L559,135 Z M772,135 L772,149 L717,149 L717,135 L772,135 Z M960,135 L960,149 L891,149 L891,135 L960,135 Z M1247,112 L1247,113 L0,113 L0,112 L1247,112 Z M115,78 L115,92 L24,92 L24,78 L115,78 Z M559,78 L559,92 L306,92 L306,78 L559,78 Z M772,78 L772,92 L717,92 L717,78 L772,78 Z M960,78 L960,92 L891,92 L891,78 L960,78 Z M1247,56 L1247,57 L0,57 L0,56 L1247,56 Z M115,21 L115,35 L24,35 L24,21 L115,21 Z M559,21 L559,35 L306,35 L306,21 L559,21 Z M772,21 L772,35 L717,35 L717,21 L772,21 Z M960,21 L960,35 L891,35 L891,21 L960,21 Z M1247,0 L1247,1 L0,1 L0,0 L1247,0 Z"
        />
      </Svg>
      <Svg className="table-stencil__mobile" width="576" height="445" viewBox="0 0 576 445" preserveAspectRatio="none">
        <path
          fillRule="evenodd"
          d="M576,444 L576,445 L0,445 L0,444 L576,444 Z M366,399 L366,413 L24,413 L24,399 L366,399 Z M223,361 L223,375 L24,375 L24,361 L223,361 Z M366,323 L366,337 L24,337 L24,323 L366,323 Z M576,296 L576,297 L0,297 L0,296 L576,296 Z M366,251 L366,265 L24,265 L24,251 L366,251 Z M223,213 L223,227 L24,227 L24,213 L223,213 Z M366,175 L366,189 L24,189 L24,175 L366,175 Z M576,148 L576,149 L0,149 L0,148 L576,148 Z M366,103 L366,117 L24,117 L24,103 L366,103 Z M223,65 L223,79 L24,79 L24,65 L223,65 Z M366,27 L366,41 L24,41 L24,27 L366,27 Z M576,0 L576,1 L0,1 L0,0 L576,0 Z"
        />
      </Svg>
    </div>
  );
}

TableStencil.propTypes = {
  className: PropTypes.string
};
